
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[protocolInstance]",
      function () {
        return require("private-next-pages/[protocolInstance].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[protocolInstance]"])
      });
    }
  